import { MessageType } from 'enums/messages';

export const SlidingPaneMode = {
  AI_MESSAGE_PANEL: 'ai-message-panel',
  MULTI_COLUMN: 'multi-column',
  ORDINARY: 'ordinary'
} as const;

export type SlidingPaneMode = (typeof SlidingPaneMode)[keyof typeof SlidingPaneMode];

export interface SlidingPaneProps {
  alertsState: {
    [MessageType.Medical]: boolean;
    [MessageType.SMS]: boolean;
    [MessageType.StaffNote]: boolean;
    [MessageType.Support]: boolean;
  };
  isDisabledMarkAsComplete: boolean;
  isMulticolumnAllowed?: boolean;
  isOpen: boolean;
  isQueue?: boolean;
  isTaskReminder?: boolean;
  mode?: SlidingPaneMode;
  taskId: string;
}
